/*  ========================================================================
    # Sections - Product Payment Types
    ========================================================================  */
import React from 'react';
import PropTypes from 'prop-types';
import useTranslation from '../../hooks/useTranslation';
import useSVGSprite from '../../hooks/useSVGSprite';

const ProductPaymentTypes = ({ types, description }) => {
  const __ = useTranslation();
  const sprite = useSVGSprite();

  return (
    <div className='s-product-overview__payments'>
      <div className='s-product-overview__payment-types'>
        <p><b>{__('payment-types-label')}</b></p>
        <ul className='s-product-overview__payment-types-list'>
          {types.map((type, index) => (
            <li key={index} className='s-product-overview__payment-type' data-type={type} aria-label={__(`payment-type-label-${type}`)}>
              <svg aria-hidden>
                <use href={`${sprite}#${type}`} />
              </svg>
            </li>
          ))}
        </ul>
      </div>
      {description && (
        <div className='s-product-overview__payment-description u-text-advisory'>{description}</div>
      )}
    </div>
  );
};

ProductPaymentTypes.propTypes = {
  types: PropTypes.array,
  description: PropTypes.string
};

export default ProductPaymentTypes;
